export const CONSONANT_VOWEL_PAIRS_D_T = [

    // ㄱ
    {
        id: 1,
        korean: "다",
        english: "da/ta",

    },
    {
        id: 2,
        korean: "데",
        english: "de/te",

    },
    {
        id: 3,
        korean: "디",
        english: "di/ti",

    },
    {
        id: 4,
        korean: "도",
        english: "do/to",

    },
    {
        id: 5,
        korean: "드",
        english: "deu/teu",

    },
    {
        id: 6,
        korean: "더",
        english: "deo/teo",

    },
    {
        id: 7,
        korean: "댜",
        english: "dya/tya",

    },
    {
        id: 8,
        korean: "대",
        english: "dae/tae",

    },
    {
        id: 9,
        korean: "뎨",
        english: "dye/tye",

    },
    {
        id: 10,
        korean: "됴",
        english: "dyo/tyo",

    },
    {
        id: 11,
        korean: "뎌",
        english: "dyoe,tyoe",

    },
    {
        id: 12,
        korean: "듀",
        english: "dyu/tyu",

        

    },

    {
        id: 13,
        korean: "단",
        english: "dan/tan",

        

    },
    {
        id: 14,
        korean: "닥",
        english: "dak/tak",

        

    },
    {
        id: 15,
        korean: "딤",
        english: "dim/tim",
        

    },
    {
        id: 16,
        korean: "닷",
        english: "dat/tat",
        

    },
    {
        id: 17,
        korean: "닿",
        english: "dah/tah",
        

    },
    {
        id: 18,
        korean: "덥",
        english: "deob/teob",
        

    },
          {
        id: 19,
        korean: "뎰",
        english: "dyel/tyel",
        

    },
    {
        id: 20,
        korean: "닺",
        english: "dat/tat",
        

    },
    {
        id: 21,
        korean: "댁",
        english: "daekk/taekk",
        

    },
    {
        id: 22,
        korean: "댄",
        english: "daen/taen",
        

    },
    {
        id: 23,
        korean: "듸",
        english: "dui/tui",
        

    },
    {
        id: 24,
        korean: "둬",
        english: "dwo/two",
        

    },

    {
        id: 25,
        korean: "댵",
        english: "dyat/tyat",
        

    },
    {
        id: 26,
        korean: "돠",
        english: "dwa/twa",
        

    },
    {
        id: 27,
        korean: "당",
        english: "dang/tang",
        
    }
    
];

